export const HOURS_MAX_DIGITS = 8;
export const HOURS_MAX_DIGITS_AFTER_DECIMAL = 2;
export const COURSE_ACTIVITY_NAME_MAX_LENGTH = 150;
